<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0">

      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat dense fixed app>
        <v-btn small flat icon @click="$router.go(-1)">
          <v-icon size="24px">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">알림</h3>
      </v-toolbar>

      <v-flex xs12 v-if="notifications.today.length || notifications.last.length">
        <v-list two-line class="pa-0 mt-2">
          <template v-for="(set, key) in notifications">
            <v-subheader :key="key" style="background-color: #f8f8f8; height: 40px;"
                         v-text="key === 'today' ? '오늘' : '지난'" v-if="set.length">
            </v-subheader>
            <div v-for="(notification, index) of set" :key="notification.idx">
              <v-list-tile avatar class="tile-align" @click="linkTo(notification.type, notification.arg1_idx)">
                <v-list-tile-avatar class="pt-3">
                  <v-img :src="notification.sender.profile_image ? `${$storage}/user/profile/${notification.sender.profile_image}` : profileImageSrc"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content class="py-3 tile-text-justify" style="height: auto;">
                  <v-list-tile-title class="tile-text">
                    <span class="tile-text-bold" v-text="notification.sender.name"></span>{{ notification.msg }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span class="caption" v-text="timeString(notification.created_at, notification.updated_at, now)"></span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action v-if="notification.image_list" class="ml-3 pt-3" style="min-width: 0;">
                  <v-img width="40px" height="40px" aspect-ratio="1" :src="`${$storage}/post/${notification.image_list[0]}`"></v-img>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider class="divider-color" v-show="set.length - 1 !== index"></v-divider>
            </div>
          </template>
        </v-list>
      </v-flex>

      <v-flex v-else>
        <div style="color: #9b9b9b;" class="my-5">
          받은 알림이 없습니다.
        </div>
      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { timeToDotString } from '@/util/util';

  export default {
    name: "Notifications",
    computed: {
      ...mapGetters([ 'now' ]),
      ...mapGetters('home', [ 'notifications' ]),
      profileImageSrc () {
        return require('@/assets/img/profile-default.png');
      }
    },
    data () {
      return {
        scrollY: 0,
        time: parseInt(new Date().getTime() / 1000),
        page: 1,
        bottom: true,
      };
    },
    created () {
      this.selectNotifications({ second: this.time, page: this.page }).then(() => {
        this.page++;
      });
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.selectNotifications({ second: this.time, page: this.page }).then(() => {
            this.page++;
          });
        }
      },
    },
    methods: {
      ...mapActions('home', [ 'selectNotifications' ]),
      getScrollY () {
        this.scrollY = window.scrollY;
        this.bottomVisible();
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 200;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
      timeString (createdAt, updatedAt, now) {
        return timeToDotString(createdAt, updatedAt, now);
      },
      linkTo (type, idx) {
        this.$router.push(`/${type}/${idx}`);
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow .v-toolbar__content {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.toolbar-padding .v-toolbar__content {
    padding: 0 10px 0 16px;
  }

  /deep/.tile-align {
    .v-list__tile {
      height: auto;
      align-items: flex-start;
    }
  }

  .tile-text {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.2px;
    color: map_get($colors, charcoal);

    text-overflow: unset;
    white-space: normal;
    word-break: keep-all;
    height: auto;
    &-justify {
      justify-content: flex-start;
    }
    &-bold {
      font-weight: 700;
    }
  }

  .divider-color {
    border-color: map_get($colors, border) !important;
  }

</style>
